import {useHttp} from '@/composable/service/useHttp';
import analyticHttp from '@/services/http/analytic.http';

// eslint-disable-next-line import/prefer-default-export
export function useAnalyticDecodeFc() {
  return useHttp(analyticHttp.decodeFcShopId);
}
